// CosmicCard.jsx → correct
import React from 'react';
import styles from './cosmicCard.module.css';

export default function CosmicCard({ delay = 0, direction = "up", children, className = "" }) {
  return (
    <div 
      className={`${styles.cosmicCard} ${className}`}   // ← allows .scroll
      style={{ 
        "--delay": `${delay}s`,
        "--direction": direction === "up" ? "-100px" : "100px"
      }}
    >
      {children}
    </div>
  );
}